
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30218',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30218",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54464",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7982",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11433",
  "I18n": "static-7.1615",
  "quartz": "static-1.6982",
  "quartz-config": "static-1.760",
  "quartz-core": "static-1.6201",
  "react-dlb": "static-1.78",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.782",
  "enviro": "static-4.428",
  "feedback-shared-ui": "static-1.54451",
  "feedback-utils": "static-1.54455",
  "forms-embed-utils-lib": "static-1.4430",
  "forms-utils-lib": "static-1.12513",
  "foundations-assets": "static-1.4830",
  "foundations-components": "static-1.7864",
  "foundations-theming": "static-1.4385",
  "hub-http": "static-1.6190",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11741",
  "icons": "static-2.644",
  "immutable": "static-2.77",
  "quick-fetch": "static-1.3888",
  "raven": "static-3.5829",
  "react": "static-7.185",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16637",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5316",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.486",
  "tinymce-plugins": "static-1.57385",
  "transmute": "static-2.85",
  "ui-images": "static-2.1143",
  "UIComponents": "static-3.8380",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9542",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3376",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3259",
  "quartz-webpack": "static-1.3206",
  "foundations-theming-specialty": "static-1.2101",
  "property-description-translator": "static-1.3814",
  "HeadJS": "static-2.745",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3093",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4294",
  "jasmine-runner": "static-1.6435",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.828",
  "hubspotter-http": "static-1.4624",
  "mobile-manifest-mixins": "static-1.519",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.657",
  "quartz-head": "static-1.647",
  "quartz-i18n": "static-1.657",
  "quartz-routing": "static-1.412",
  "quartz-test": "static-1.657",
  "quartz-tracking": "static-1.361",
  "ui-fonts": "static-1.695",
  "usage-tracker-container": "static-1.7303",
  "usage-tracker-core": "static-1.7163",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.155",
  "conversations-skeleton-state": "static-1.7216",
  "reference-resolvers": "static-1.8137",
  "sanitize-text": "static-1.8110",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10338",
  "sanitize": "static-1.4443",
  "outpost": "static-1.4154",
  "rpc-client-utils": "static-1.4619",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4133",
  "floating-ui": "static-1.55",
  "hs-story-utils": "static-1.9397",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.13",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1763",
  "bend-plugin-foundations-theming": "static-1.2868",
  "foundations-theming-base": "static-1.3370",
  "stylex": "static-1.32",
  "hs-locale-management": "static-1.57",
  "csstype": "static-1.50",
  "web-vitals": "static-1.4",
  "ai-components-ui-library": "static-1.8855",
  "atom": "static-1.5039",
  "codemirror": "static-5.94",
  "content-assistance-lib": "static-1.7698",
  "ContentUtils": "static-1.68264",
  "data-token-picker": "static-1.16345",
  "file-manager-components": "static-1.23524",
  "FileManagerCore": "static-1.39023",
  "FileManagerLib": "static-1.39164",
  "frontend-preferences-client": "static-1.7897",
  "hub-http-contrib": "static-1.3007",
  "interframe": "static-3.4728",
  "layout-dnd-components": "static-1.12378",
  "layout-dnd-utils": "static-1.11353",
  "property-translator": "static-1.5369",
  "react-codemirror": "static-1.10593",
  "react-colorpicker": "static-2.10178",
  "reference-resolvers-lite": "static-1.8063",
  "rich-text-lib": "static-1.19771",
  "tinymce-data": "static-1.40356",
  "tinymce-themes": "static-1.56241",
  "ui-addon-emoji-picker": "static-1.9855",
  "ui-addon-sales-email": "static-1.5178",
  "ui-brand-identity-lib": "static-1.15123",
  "bender-build-tools": "static-1.3160",
  "hub-http-shared-msw-handlers": "static-1.9882",
  "hubspotter-http-shared-msw-handlers": "static-1.9880",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "usage-tracker-session-replay": "static-1.4999",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.29",
  "chirp-fetch": "static-1.1855",
  "chatspot-core": "static-1.21137",
  "copilot-toolkit": "static-1.11048",
  "customer-data-objects-ui-components": "static-1.12993",
  "data-fetching-client": "static-1.9640",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4734",
  "ui-addon-video-player": "static-1.8668",
  "ui-coaching-tips": "static-1.28455",
  "usage-tracker": "static-1.7313",
  "cms-field-types": "static-1.4780",
  "content-icons-ui": "static-1.2216",
  "integrations-lib": "static-1.16011",
  "customer-data-objects": "static-1.7630",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4617",
  "apollo-stack-hubspot": "static-3.85",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "immerable": "static-1.4122",
  "ui-addon-iframeable": "static-1.9025",
  "video-components-external": "static-1.11163",
  "video-data-lib": "static-1.34821",
  "audio-components": "static-1.5863",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29234",
  "FileManagerImages": "static-1.36675",
  "foundations-components-legacy": "static-1.889",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.524",
  "ui-universal-auth": "static-1.8937",
  "urlinator": "static-1.4501",
  "video-components": "static-1.13166",
  "video-embed": "static-1.35655",
  "ts-schema": "static-1.4050",
  "ContentData": "static-1.68339",
  "layout-data-lib": "static-1.9678",
  "react-dnd-compat": "static-1.4588",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1510",
  "external-options-client-types": "static-1.4130",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6849",
  "hs-promise-utils": "static-1.5562",
  "inbound-db-properties-service-client": "static-1.3815",
  "NamespacedHubStyle": "static-2.9034",
  "growth-onboarding-confetti": "static-1.3035",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11118",
  "amplitude-session-replay-browser": "static-1.59",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5536",
  "magpie-types": "static-1.4996",
  "simple-logging-lib": "static-1.3017",
  "avatar-components": "static-1.2466",
  "customer-data-ui-utilities": "static-1.9794",
  "growth-onboarding-feedback-components": "static-1.6550",
  "flux-actions": "static-1.331",
  "hubspot-apollo-client": "static-1.4845",
  "integrations-error-boundary-lib": "static-1.13426",
  "integrations-tracking-lib": "static-1.5567",
  "laboratory-lib": "static-3.7127",
  "native-integrations-shared-strings": "static-1.7750",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10122",
  "unified-auth": "static-1.451",
  "navigation-messaging": "static-1.7252",
  "content-media-composition-data-lib": "static-1.12149",
  "content-media-compositions": "static-2.16156",
  "idb-keyval": "static-1.43",
  "media-bridge-lib": "static-1.18867",
  "unified-auth-core-lib": "static-1.732",
  "social-insights-client-types": "static-1.22004",
  "advanced-menus-core": "static-1.15077",
  "advanced-menus-lib": "static-1.12025",
  "ExportDialog": "static-6.10361",
  "ui-memberships-settings-lib": "static-1.33953",
  "conditional-properties-service-client": "static-1.3769",
  "crm-pipelines-api-client-types": "static-1.4114",
  "framework-builder-read-service-client": "static-1.3981",
  "framework-data-schema-quick-fetch": "static-1.6754",
  "inbound-db-meta-service-client": "static-1.3562",
  "multi-currency-client-types": "static-1.3663",
  "persist-promise": "static-1.3667",
  "foundations-components-test-utils": "static-1.5347",
  "reactive-lib": "static-1.690",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.304",
  "universal-page-editor-lib": "static-1.2981",
  "google-sheets-integration-lib": "static-1.139",
  "microsoft-drive-integration-lib": "static-1.256",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3700",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15076",
  "simple-menus-lib": "static-1.16593",
  "crm-record-cards-service-types": "static-1.3580",
  "location-customization-utils-lib": "static-1.9154",
  "react-flip-move": "static-1.69"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30218",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54464",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7982",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11433",
  "I18n": "/I18n/static-7.1615",
  "quartz": "/quartz/static-1.6982",
  "quartz-config": "/quartz-config/static-1.760",
  "quartz-core": "/quartz-core/static-1.6201",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.782",
  "enviro": "/enviro/static-4.428",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54451",
  "feedback-utils": "/feedback-utils/static-1.54455",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4430",
  "forms-utils-lib": "/forms-utils-lib/static-1.12513",
  "foundations-assets": "/foundations-assets/static-1.4830",
  "foundations-components": "/foundations-components/static-1.7864",
  "foundations-theming": "/foundations-theming/static-1.4385",
  "hub-http": "/hub-http/static-1.6190",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11741",
  "icons": "/icons/static-2.644",
  "immutable": "/immutable/static-2.77",
  "quick-fetch": "/quick-fetch/static-1.3888",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.185",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16637",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5316",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tinymce-plugins": "/tinymce-plugins/static-1.57385",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1143",
  "UIComponents": "/UIComponents/static-3.8380",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9542",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3376",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3259",
  "quartz-webpack": "/quartz-webpack/static-1.3206",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2101",
  "property-description-translator": "/property-description-translator/static-1.3814",
  "HeadJS": "/HeadJS/static-2.745",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3093",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4294",
  "jasmine-runner": "/jasmine-runner/static-1.6435",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.828",
  "hubspotter-http": "/hubspotter-http/static-1.4624",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.519",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.657",
  "quartz-head": "/quartz-head/static-1.647",
  "quartz-i18n": "/quartz-i18n/static-1.657",
  "quartz-routing": "/quartz-routing/static-1.412",
  "quartz-test": "/quartz-test/static-1.657",
  "quartz-tracking": "/quartz-tracking/static-1.361",
  "ui-fonts": "/ui-fonts/static-1.695",
  "usage-tracker-container": "/usage-tracker-container/static-1.7303",
  "usage-tracker-core": "/usage-tracker-core/static-1.7163",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.155",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7216",
  "reference-resolvers": "/reference-resolvers/static-1.8137",
  "sanitize-text": "/sanitize-text/static-1.8110",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10338",
  "sanitize": "/sanitize/static-1.4443",
  "outpost": "/outpost/static-1.4154",
  "rpc-client-utils": "/rpc-client-utils/static-1.4619",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4133",
  "floating-ui": "/floating-ui/static-1.55",
  "hs-story-utils": "/hs-story-utils/static-1.9397",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.13",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1763",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2868",
  "foundations-theming-base": "/foundations-theming-base/static-1.3370",
  "stylex": "/stylex/static-1.32",
  "hs-locale-management": "/hs-locale-management/static-1.57",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.4",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8855",
  "atom": "/atom/static-1.5039",
  "codemirror": "/codemirror/static-5.94",
  "content-assistance-lib": "/content-assistance-lib/static-1.7698",
  "ContentUtils": "/ContentUtils/static-1.68264",
  "data-token-picker": "/data-token-picker/static-1.16345",
  "file-manager-components": "/file-manager-components/static-1.23524",
  "FileManagerCore": "/FileManagerCore/static-1.39023",
  "FileManagerLib": "/FileManagerLib/static-1.39164",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7897",
  "hub-http-contrib": "/hub-http-contrib/static-1.3007",
  "interframe": "/interframe/static-3.4728",
  "layout-dnd-components": "/layout-dnd-components/static-1.12378",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11353",
  "property-translator": "/property-translator/static-1.5369",
  "react-codemirror": "/react-codemirror/static-1.10593",
  "react-colorpicker": "/react-colorpicker/static-2.10178",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8063",
  "rich-text-lib": "/rich-text-lib/static-1.19771",
  "tinymce-data": "/tinymce-data/static-1.40356",
  "tinymce-themes": "/tinymce-themes/static-1.56241",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9855",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5178",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15123",
  "bender-build-tools": "/bender-build-tools/static-1.3160",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9882",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9880",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4999",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.29",
  "chirp-fetch": "/chirp-fetch/static-1.1855",
  "chatspot-core": "/chatspot-core/static-1.21137",
  "copilot-toolkit": "/copilot-toolkit/static-1.11048",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12993",
  "data-fetching-client": "/data-fetching-client/static-1.9640",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4734",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8668",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28455",
  "usage-tracker": "/usage-tracker/static-1.7313",
  "cms-field-types": "/cms-field-types/static-1.4780",
  "content-icons-ui": "/content-icons-ui/static-1.2216",
  "integrations-lib": "/integrations-lib/static-1.16011",
  "customer-data-objects": "/customer-data-objects/static-1.7630",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4617",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4122",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9025",
  "video-components-external": "/video-components-external/static-1.11163",
  "video-data-lib": "/video-data-lib/static-1.34821",
  "audio-components": "/audio-components/static-1.5863",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29234",
  "FileManagerImages": "/FileManagerImages/static-1.36675",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.889",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.524",
  "ui-universal-auth": "/ui-universal-auth/static-1.8937",
  "urlinator": "/urlinator/static-1.4501",
  "video-components": "/video-components/static-1.13166",
  "video-embed": "/video-embed/static-1.35655",
  "ts-schema": "/ts-schema/static-1.4050",
  "ContentData": "/ContentData/static-1.68339",
  "layout-data-lib": "/layout-data-lib/static-1.9678",
  "react-dnd-compat": "/react-dnd-compat/static-1.4588",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1510",
  "external-options-client-types": "/external-options-client-types/static-1.4130",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6849",
  "hs-promise-utils": "/hs-promise-utils/static-1.5562",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3815",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9034",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3035",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11118",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5536",
  "magpie-types": "/magpie-types/static-1.4996",
  "simple-logging-lib": "/simple-logging-lib/static-1.3017",
  "avatar-components": "/avatar-components/static-1.2466",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9794",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6550",
  "flux-actions": "/flux-actions/static-1.331",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4845",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13426",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5567",
  "laboratory-lib": "/laboratory-lib/static-3.7127",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7750",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10122",
  "unified-auth": "/unified-auth/static-1.451",
  "navigation-messaging": "/navigation-messaging/static-1.7252",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12149",
  "content-media-compositions": "/content-media-compositions/static-2.16156",
  "idb-keyval": "/idb-keyval/static-1.43",
  "media-bridge-lib": "/media-bridge-lib/static-1.18867",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.732",
  "social-insights-client-types": "/social-insights-client-types/static-1.22004",
  "advanced-menus-core": "/advanced-menus-core/static-1.15077",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12025",
  "ExportDialog": "/ExportDialog/static-6.10361",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33953",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3769",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4114",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3981",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6754",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3562",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3663",
  "persist-promise": "/persist-promise/static-1.3667",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5347",
  "reactive-lib": "/reactive-lib/static-1.690",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.304",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2981",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.139",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.256",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3700",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15076",
  "simple-menus-lib": "/simple-menus-lib/static-1.16593",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3580",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9154",
  "react-flip-move": "/react-flip-move/static-1.69"
}
};
